import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {throwError} from 'rxjs';
import {MailService} from './list.service';

@Component({
  selector: 'mail-details',
  templateUrl: 'details.component.html',
  providers: [MailService],
})
export class DetailsComponent implements OnInit {
  public mail = {};
  public group = 'mail';
  public visuals: any = {};
  public loading = true;

  public categories = [
    {
      visual: 'Inbox',
      icon: 'inbox',
      type: 'I',
    },
    {
      visual: 'Deleted',
      icon: 'trash',
      type: 'D',
    },
  ];

  constructor(
    public mailService: MailService,
    public securityService: SecurityService,
    public logger: LogService,
    public visualsService: VisualsService,
    public eventsEmitterService: EventsEmitterService,
    public route: ActivatedRoute,
    public router: Router,
  ) {
    this.getVisuals();

    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.getVisuals();
      },
    });
  }

  ngOnInit() {
    this.route.params.subscribe({
      next: (params) => {
        this.logger.log(params);
        let mailId = params['id'] || null;
        if (mailId != null) {
          this.mailService.getMailDetails(mailId).subscribe({
            next: (data) => {
              this.logger.log(data);
              this.loading = false;
              this.mail = data;
              this.eventsEmitterService.unreadMailChange.emit();
            },
            error: (error) => {
              this.loading = false;
              return throwError(() => new Error(error));
            },
          });
        } else {
          this.router.navigateByUrl('menu/list');
        }
      },
    });
  }

  public getVisuals() {
    this.visuals = this.visualsService.getFromStorageAsJSON('visualsArray')[this.group];
  }
}
